export default (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const isRequired = (value) => (value ? undefined : 'Required');

export const isValidUrl = (value) => {
  if (value === undefined) return;

  // Special case for fragment-only URLs
  if (value.startsWith('#')) {
    return undefined; // All fragments are valid
  }
  
  // Check for proper URL encoding
  try {
    decodeURIComponent(value);
  } catch (e) {
    return 'Must be a valid url';
  }

  // Parse URL to handle the base and fragment separately
  let baseUrl = value;
  
  if (value.includes('#')) {
    [baseUrl] = value.split('#', 2);
  }
  
  // Only check for invalid text fragment format if we have a colon after the path
  // This is more precise than the previous regex
  if (baseUrl.includes(':~:text=')) {
    return 'Must be a valid url'; // This is definitely invalid
  }
  
  // Check if the base URL (without fragment) is valid
  const baseUrlPattern = /^((http|https):\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,5})?(\/[^\s]*)?(\?[^\s]*)?$/;
  const mailtoPattern = /^mailto:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
  return baseUrlPattern.test(baseUrl) || mailtoPattern.test(value)
    ? undefined
    : 'Must be a valid url';
};



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/utils/validation.js